import React from 'react'

import './messages-split-layout.scss'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
  }
>

// TODO maybe we can merge this with MaterialActivationLayout?
const MessagesSplitLayout = ({className, children, ...props}: Props) => (
  <div {...props} className={cn('MessagesSplitLayout', {}, className)}>
    {children}
  </div>
)

export default MessagesSplitLayout
